module.exports = __webpack_public_path__ + "img/category-popular.11414ee3.png";